module.exports = __webpack_public_path__ + "media/images/course/4-76e966b3669583e9b0dbd456db2152b9.png";